import { DateRangePickerComponent } from "../components/form/DateRangePickerComponent";
import { DateRange } from "react-day-picker";
import { useEffect, useState } from "react";
import { Label } from "../components/form/Label";
import Dropdown from "../components/form/Dropdown";
import { OrdersCard } from "../components/user_rentals/OrdersCard";
import { NoneUserRented } from "./NoneUserRentedPage";
import CarRentalIcon from '@mui/icons-material/CarRental';
import { RentalStatus } from "../api/requests/interfaces/Channel";
import { getUserRentals } from "../api/requests/rental";
import { UserRentalDetail } from "../api/requests/interfaces/Rental";
import { productStatusOptions } from "../constants/products";
import { Helmet } from "react-helmet-async";
import {Pagination} from "@mui/material";
import {Spinner} from "../components/common/Spinner";
export const UserRentedList = () => {

    const [filterSearch, setFilterSearch] = useState<string | undefined>(String);
    const [filterDate, setFilterDate] = useState<DateRange | undefined>();
    const [filterStatus, setFilterStatus] = useState<RentalStatus | undefined>(undefined);
    const [rentals, setRentals] = useState<UserRentalDetail[]>([]);
    const [loadingRentals, setLoadingRentals] = useState(true);

    const [rentedPage, setRentedPage] = useState(0);
    const [takeRentedCount, setTakeRentedCount] = useState(10);
    const [rentedTotalCount, setRentedTotalCount] = useState(0);

    const [initialRentalsLoad, setInitialRentalsLoad] = useState<UserRentalDetail[]>([]);

    useEffect(() => {
        fetchUserRentals();
        window.scrollTo(0, 0);
    }, [])

    useEffect(() => {
        fetchUserRentals();
    }, [filterSearch, filterDate, filterStatus, rentedPage, takeRentedCount])

    const fetchUserRentals = async () => {
        setLoadingRentals(true);
        setRentals([]); // Without this line for some odd reason a random rental will stay in the list
        const data = await getUserRentals(false, takeRentedCount*rentedPage, takeRentedCount,
            filterDate?.from, filterDate?.to, filterStatus);
        setRentals(data.data);
        setRentedTotalCount(data.total);
        if (!initialRentalsLoad.length) {
            setInitialRentalsLoad(data.data);
        }
        setLoadingRentals(false);
    }

    return (
        initialRentalsLoad.length || loadingRentals ?
            (<div className="pt-[30px]">

                <Helmet>
                    <title>Rentic - Minu Tellimused</title>
                    <meta name="description" content="Mulle renditud asjad Rentic rendiplatformil. Vaata üksikasju endale renditud esemete kohta." />
                    <meta name="keywords" content="rentic, renditud esemed, renditud teenused, renditud, my orders, my rented items" />
                    <meta property="og:title" content="Rentic - Mulle Renditud" />
                    <meta property="og:description" content="Mulle renditud asjad Rentic rendiplatformil. Vaata üksikasju endale renditud esemete kohta." />
                    <meta property="og:image" content="/logo512.png" />
                    <meta property="og:url" content="https://rentic.ee/my-orders" />
                </Helmet>

                <h2 className="text-left pb-5">Mulle renditud asjad</h2>
                <div className="flex flex-row flex-wrap w-full gap-y-3 gap-x-6 bg-blue-50 p-3 pl-5 pb-2 mb-8 rounded-xl">
                    <div className="w-full lg:w-[220px]">
                        <Label value={"Staatus"} />
                        <Dropdown options={productStatusOptions} isMultiSelect={false} onSelect={(value) => {
                            const selectedStatus = productStatusOptions.find(option => option.value === value[0])?.value;
                            setFilterStatus(selectedStatus);
                        }} />
                    </div>
                    <div className="w-full lg:w-[280px]">
                        <Label value={"Rendiperiood"} />
                        <DateRangePickerComponent dateRangeChanged={(d) => { setFilterDate(d) }} validChanged={(v) => { console.log(v) }} disablePastDates={false} />
                    </div>

                </div>
                {
                    loadingRentals ?
                        <div className="flex flex-row justify-center">
                            <Spinner />
                        </div>
                        :
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
                            {rentals.map((item, index) => {
                                return (
                                    <OrdersCard
                                        key={index}
                                        data={item}
                                    />
                                );
                            })}
                        </div>
                }
                <div className="flex justify-center mt-4">
                    <Pagination count={Math.floor(rentedTotalCount / takeRentedCount)} page={rentedPage + 1}
                                onChange={(e, p) => setRentedPage(p - 1)}/>
                </div>
            </div>
            ) :
            <NoneUserRented text={"Sa pole rentinud veel ühtegi asja."} buttonLink="/" buttonText="Rendi midagi" icon={<CarRentalIcon className="text-primary" style={{ height: "100px", width: "100px" }} />} />
    )

}